<div class="container px-5 pt-5 mt-md-3 dashboard-container">
  <div class="row mb-3">
    <div class="col-12">
      <button (click)="openLanguageSelection()" class="btn btn-outline-success btn-lg bg-white go-back-btn" type="button">
        {{ backButtonTranslation | translate }}
      </button>
    </div>
  </div>
  <div class="row justify-content-center mb-4">
    <div class="col-12 text-center">
      <button (click)="startNewApplication()" class="btn btn-success btn-lg start-application-btn" type="button">
        {{ translationPrefix + '.actions.startNew' | translate }}
      </button>
    </div>
  </div>

  <div class="dashboard-table-section">
    <h2 class="dashboard-title">{{ translationPrefix + '.table.title' | translate }}</h2>

    <div class="table-responsive">
      <table class="table dashboard-table" [attr.aria-busy]="loading">
        <thead class="dashboard-table-header">
          <tr>
            <th>{{ translationPrefix + '.table.columns.applicationStatus' | translate }}</th>
            <th>{{ translationPrefix + '.table.columns.requestedEffDate' | translate }}</th>
            <th
              class="table-header-sortable"
              [class.table-header-sortable-desc]="sortDateDirection === 'desc'"
              [class.table-header-sortable-asc]="sortDateDirection === 'asc'"
            >
              <button (click)="toggleDateSort()" [disabled]="loading" class="dashboard-sort-button" type="button">
                <span>{{ translationPrefix + '.table.columns.dateCreatedSubmitted' | translate }}</span>
                <div class="arrow-wrapper">
                  <span class="custom-arrows">
                    <span class="up"></span>
                    <span class="down"></span>
                  </span>
                </div>
              </button>
            </th>
            <th>{{ translationPrefix + '.table.columns.applicationType' | translate }}</th>
            <th>{{ translationPrefix + '.table.columns.action' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @if (loading) { @for (row of skeletonRows; track row) {
          <tr [class.dashboard-table-row-alt]="$even">
            <td><span class="dashboard-skeleton-line" style="width: 72%"></span></td>
            <td><span class="dashboard-skeleton-line" style="width: 58%"></span></td>
            <td><span class="dashboard-skeleton-line" style="width: 88%"></span></td>
            <td><span class="dashboard-skeleton-line" style="width: 40%"></span></td>
            <td><span class="dashboard-skeleton-line dashboard-skeleton-button"></span></td>
          </tr>
          } } @else if (applications.length === 0) {
          <tr>
            <td colspan="5" class="text-center py-4">{{ translationPrefix + '.table.noApplications' | translate }}</td>
          </tr>
          } @else { @for (app of applications; track app.id; let i = $index) {
          <tr [class.dashboard-table-row-alt]="i % 2 === 0">
            <td>{{ displayStatus(app) | translate }}</td>
            <td>{{ formatRequestedEffDate(getDisplayEffectiveDate(app)) }}</td>
            <td>{{ formatDateCreatedSubmitted(app) }}</td>
            <td>{{ displayApplicationType(app.applicationType) | translate}}</td>
            <td>
              <button (click)="reviewApplication(app)" class="btn btn-sm btn-review" type="button">
                {{ getActionLabel(app) | translate }}
              </button>
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>

    @if (!loading && totalCount > 0) {
    <div class="dashboard-pagination" role="navigation" [attr.aria-label]="(translationPrefix + '.table.pagination.ariaLabel') | translate">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm dashboard-pagination-btn"
        (click)="goToPreviousPage()"
        [disabled]="!canGoPrevious"
      >
        {{ translationPrefix + '.table.pagination.previous' | translate }}
      </button>
      <span class="dashboard-pagination-status"
        >{{ (translationPrefix + '.table.pagination.pageOf') | translate: { current: currentPage, total: totalPages } }}</span
      >
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm dashboard-pagination-btn"
        (click)="goToNextPage()"
        [disabled]="!canGoNext"
      >
        {{ translationPrefix + '.table.pagination.next' | translate }}
      </button>
    </div>
    }
  </div>
</div>
